/* 🤖 this file was generated by svg-to-ts */

import { SiriusIcon } from './build/sirius-icons.model';

export type SiriusIconNameSubset<
  T extends Readonly<SiriusIcon[]>
> = T[number]['name'];

export * from './build/sirius-apple-podcasts-logo-duotone.icon';
export * from './build/sirius-arrow-fat-lines-right-duotone.icon';
export * from './build/sirius-barbell-duotone.icon';
export * from './build/sirius-barcode-duotone.icon';
export * from './build/sirius-bell-duotone.icon';
export * from './build/sirius-binoculars-duotone.icon';
export * from './build/sirius-book-open-text-duotone.icon';
export * from './build/sirius-bookmark-simple-duotone.icon';
export * from './build/sirius-books-duotone.icon';
export * from './build/sirius-briefcase-duotone.icon';
export * from './build/sirius-bug-duotone.icon';
export * from './build/sirius-calendar-blank-duotone.icon';
export * from './build/sirius-chart-bar-horizontal-duotone.icon';
export * from './build/sirius-chart-bar-vertical-duotone.icon';
export * from './build/sirius-chart-line-up-duotone.icon';
export * from './build/sirius-chat-centered-duotone.icon';
export * from './build/sirius-chat-centered-text-duotone.icon';
export * from './build/sirius-chats-duotone.icon';
export * from './build/sirius-check-circle-duotone.icon';
export * from './build/sirius-circle-half-tilt-duotone.icon';
export * from './build/sirius-clipboard-plus-duotone.icon';
export * from './build/sirius-clipboard-text-duotone.icon';
export * from './build/sirius-clock-duotone.icon';
export * from './build/sirius-closed-captioning-duotone.icon';
export * from './build/sirius-cloud-arrow-down-duotone.icon';
export * from './build/sirius-cloud-arrow-up-duotone.icon';
export * from './build/sirius-cloud-check-duotone.icon';
export * from './build/sirius-cloud-duotone.icon';
export * from './build/sirius-cobot-line-duotone.icon';
export * from './build/sirius-codepen-logo-duotone.icon';
export * from './build/sirius-cookie-duotone.icon';
export * from './build/sirius-copy-duotone.icon';
export * from './build/sirius-copyright-duotone.icon';
export * from './build/sirius-credit-card-duotone.icon';
export * from './build/sirius-crop-duotone.icon';
export * from './build/sirius-crosshair-duotone.icon';
export * from './build/sirius-cube-duotone.icon';
export * from './build/sirius-currency-dollar-simple-duotone.icon';
export * from './build/sirius-cylinder-duotone.icon';
export * from './build/sirius-database-duotone.icon';
export * from './build/sirius-desktop-duotone.icon';
export * from './build/sirius-device-duotone.icon';
export * from './build/sirius-dots-three-horisontal-duotone.icon';
export * from './build/sirius-dots-three-vertical-duotone.icon';
export * from './build/sirius-drop-duotone.icon';
export * from './build/sirius-envelope-open-duotone.icon';
export * from './build/sirius-eraser-duotone.icon';
export * from './build/sirius-eye-duotone.icon';
export * from './build/sirius-eye-slash-duotone.icon';
export * from './build/sirius-eyec-closed-duotone.icon';
export * from './build/sirius-facebook-logo-duotone.icon';
export * from './build/sirius-file-arrow-down-duotone.icon';
export * from './build/sirius-file-arrow-up-duotone.icon';
export * from './build/sirius-file-doc-duotone.icon';
export * from './build/sirius-file-html-duotone.icon';
export * from './build/sirius-file-jpg-duotone.icon';
export * from './build/sirius-file-pdf-duotone.icon';
export * from './build/sirius-file-png-duotone.icon';
export * from './build/sirius-file-ppt-duotone.icon';
export * from './build/sirius-file-xls-duotone.icon';
export * from './build/sirius-file-zip-duotone.icon';
export * from './build/sirius-flame-duotone.icon';
export * from './build/sirius-flask-duotone.icon';
export * from './build/sirius-fork-knife-duotone.icon';
export * from './build/sirius-funnel-duotone.icon';
export * from './build/sirius-gauge-duotone.icon';
export * from './build/sirius-gear-duotone.icon';
export * from './build/sirius-ghost-duotone.icon';
export * from './build/sirius-git-branch-duotone.icon';
export * from './build/sirius-git-fork-duotone.icon';
export * from './build/sirius-globe-duotone.icon';
export * from './build/sirius-globe-stand-duotone.icon';
export * from './build/sirius-graduation-cap-duotone.icon';
export * from './build/sirius-graph-duotone.icon';
export * from './build/sirius-handshake-duotone.icon';
export * from './build/sirius-headset-duotone.icon';
export * from './build/sirius-heart-duotone.icon';
export * from './build/sirius-heartbeat-duotone.icon';
export * from './build/sirius-house-duotone.icon';
export * from './build/sirius-image-duotone.icon';
export * from './build/sirius-info-duotone.icon';
export * from './build/sirius-instagram-logo-duotone.icon';
export * from './build/sirius-leaf-duotone.icon';
export * from './build/sirius-linkedin-logo-duotone.icon';
export * from './build/sirius-list-bullets-duotone.icon';
export * from './build/sirius-list-checks-duotone.icon';
export * from './build/sirius-list-plus-duotone.icon';
export * from './build/sirius-lock-simple-duotone.icon';
export * from './build/sirius-lock-simple-open-duotone.icon';
export * from './build/sirius-magnifying-glass-duotone.icon';
export * from './build/sirius-magnifying-glass-minus-duotone.icon';
export * from './build/sirius-magnifying-glass-plus-duotone.icon';
export * from './build/sirius-map-pin-duotone.icon';
export * from './build/sirius-monitor-duotone.icon';
export * from './build/sirius-moon-duotone.icon';
export * from './build/sirius-needle-duotone.icon';
export * from './build/sirius-notepad-duotone.icon';
export * from './build/sirius-nut-duotone.icon';
export * from './build/sirius-package-duotone.icon';
export * from './build/sirius-paint-brush-broad-duotone.icon';
export * from './build/sirius-pencil-duotone.icon';
export * from './build/sirius-pencil-ruler-duotone.icon';
export * from './build/sirius-person-simple-circle-duotone.icon';
export * from './build/sirius-play-circle-duotone.icon';
export * from './build/sirius-plugs-connected-duotone.icon';
export * from './build/sirius-plugs-duotone.icon';
export * from './build/sirius-printer-duotone.icon';
export * from './build/sirius-question-duotone.icon';
export * from './build/sirius-quotes-duotone.icon';
export * from './build/sirius-repeat-duotone.icon';
export * from './build/sirius-robot-duotone.icon';
export * from './build/sirius-rocket-launch-duotone.icon';
export * from './build/sirius-rows-duotone.icon';
export * from './build/sirius-ruler-duotone.icon';
export * from './build/sirius-scales-duotone.icon';
export * from './build/sirius-selection-background-duotone.icon';
export * from './build/sirius-share-network-duotone.icon';
export * from './build/sirius-shield-check-duotone.icon';
export * from './build/sirius-shield-duotone.icon';
export * from './build/sirius-shipinhao-logo-duotone.icon';
export * from './build/sirius-shopping-cart-duotone.icon';
export * from './build/sirius-shuffle-duotone.icon';
export * from './build/sirius-shuffle-up-duotone.icon';
export * from './build/sirius-sliders-horizontal-duotone.icon';
export * from './build/sirius-sliders-vertical-duotone.icon';
export * from './build/sirius-smalldots-three-horisontal-duotone.icon';
export * from './build/sirius-smalldots-three-vertical-duotone.icon';
export * from './build/sirius-sparkle-duotone.icon';
export * from './build/sirius-speaker-high-duotone.icon';
export * from './build/sirius-speaker-slash-duotone.icon';
export * from './build/sirius-speaker-x-duotone.icon';
export * from './build/sirius-speed-high-duotone.icon';
export * from './build/sirius-speed-low-duotone.icon';
export * from './build/sirius-speed-medium-duotone.icon';
export * from './build/sirius-spotify-logo-duotone.icon';
export * from './build/sirius-square-half-horisontal-duotone.icon';
export * from './build/sirius-square-half-vertical-duotone.icon';
export * from './build/sirius-squares-four-duotone.icon';
export * from './build/sirius-stack-duotone.icon';
export * from './build/sirius-stamp-duotone.icon';
export * from './build/sirius-star-duotone.icon';
export * from './build/sirius-sticker-duotone.icon';
export * from './build/sirius-student-duotone.icon';
export * from './build/sirius-sun-duotone.icon';
export * from './build/sirius-swap-duotone.icon';
export * from './build/sirius-swatches-duotone.icon';
export * from './build/sirius-syringe-duotone.icon';
export * from './build/sirius-tag-duotone.icon';
export * from './build/sirius-target-duotone.icon';
export * from './build/sirius-telegram-logo-duotone.icon';
export * from './build/sirius-test-tube-duotone.icon';
export * from './build/sirius-thermometer-simple-duotone.icon';
export * from './build/sirius-thumbs-down-duotone.icon';
export * from './build/sirius-thumbs-up-duotone.icon';
export * from './build/sirius-ticket-duotone.icon';
export * from './build/sirius-tiktok-logo-duotone.icon';
export * from './build/sirius-timer-duotone.icon';
export * from './build/sirius-trash-duotone.icon';
export * from './build/sirius-tree-duotone.icon';
export * from './build/sirius-tree-evergreen-duotone.icon';
export * from './build/sirius-truck-duotone.icon';
export * from './build/sirius-twitter-logo-duotone.icon';
export * from './build/sirius-user-circle-duotone.icon';
export * from './build/sirius-user-duotone.icon';
export * from './build/sirius-user-minus-duotone.icon';
export * from './build/sirius-user-plus-duotone.icon';
export * from './build/sirius-users-four-duotone.icon';
export * from './build/sirius-users-three-duotone.icon';
export * from './build/sirius-users-two-duotone.icon';
export * from './build/sirius-warning-circle-duotone.icon';
export * from './build/sirius-wechat-logo-duotone.icon';
export * from './build/sirius-weishi-logo-duotone.icon';
export * from './build/sirius-world-duotone.icon';
export * from './build/sirius-wrench-duotone.icon';
export * from './build/sirius-x-circle-duotone.icon';
export * from './build/sirius-x-logo-duotone.icon';
export * from './build/sirius-youtube-logo-duotone.icon';
export * from './build/sirius-apple-podcasts-logo.icon';
export * from './build/sirius-arrow-down-left-small.icon';
export * from './build/sirius-arrow-down-left.icon';
export * from './build/sirius-arrow-down-right-small.icon';
export * from './build/sirius-arrow-down-right.icon';
export * from './build/sirius-arrow-down-small.icon';
export * from './build/sirius-arrow-down.icon';
export * from './build/sirius-arrow-fat-lines-right.icon';
export * from './build/sirius-arrow-left-small.icon';
export * from './build/sirius-arrow-left.icon';
export * from './build/sirius-arrow-right-small.icon';
export * from './build/sirius-arrow-right.icon';
export * from './build/sirius-arrow-square-in.icon';
export * from './build/sirius-arrow-square-out.icon';
export * from './build/sirius-arrow-up-left-small.icon';
export * from './build/sirius-arrow-up-left.icon';
export * from './build/sirius-arrow-up-right-small.icon';
export * from './build/sirius-arrow-up-right.icon';
export * from './build/sirius-arrow-up-small.icon';
export * from './build/sirius-arrow-up.icon';
export * from './build/sirius-arrows-down-up.icon';
export * from './build/sirius-arrows-in.icon';
export * from './build/sirius-arrows-out.icon';
export * from './build/sirius-barbell.icon';
export * from './build/sirius-bell.icon';
export * from './build/sirius-binoculars.icon';
export * from './build/sirius-book-open-text.icon';
export * from './build/sirius-bookmark-simple.icon';
export * from './build/sirius-books.icon';
export * from './build/sirius-briefcase.icon';
export * from './build/sirius-bug.icon';
export * from './build/sirius-bullet.icon';
export * from './build/sirius-calendar-blank.icon';
export * from './build/sirius-caret-down-small.icon';
export * from './build/sirius-caret-down.icon';
export * from './build/sirius-caret-left-small.icon';
export * from './build/sirius-caret-left.icon';
export * from './build/sirius-caret-right-small.icon';
export * from './build/sirius-caret-right.icon';
export * from './build/sirius-caret-up-small.icon';
export * from './build/sirius-caret-up.icon';
export * from './build/sirius-chart-bar-horizontal.icon';
export * from './build/sirius-chart-bar-vertical.icon';
export * from './build/sirius-chart-line-up.icon';
export * from './build/sirius-chat-centered-text.icon';
export * from './build/sirius-chat-centered.icon';
export * from './build/sirius-chats.icon';
export * from './build/sirius-check-circle.icon';
export * from './build/sirius-check.icon';
export * from './build/sirius-circle-half-tilt.icon';
export * from './build/sirius-circle-wavy-check.icon';
export * from './build/sirius-clipboard-plus.icon';
export * from './build/sirius-clipboard-text.icon';
export * from './build/sirius-clock.icon';
export * from './build/sirius-closed-captioning.icon';
export * from './build/sirius-cloud-arrow-down.icon';
export * from './build/sirius-cloud-arrow-up.icon';
export * from './build/sirius-cloud-check.icon';
export * from './build/sirius-cloud.icon';
export * from './build/sirius-cobot-line.icon';
export * from './build/sirius-codepen-logo.icon';
export * from './build/sirius-cookie.icon';
export * from './build/sirius-copy.icon';
export * from './build/sirius-copyright.icon';
export * from './build/sirius-corners-out.icon';
export * from './build/sirius-credit-card.icon';
export * from './build/sirius-crosshair.icon';
export * from './build/sirius-cube.icon';
export * from './build/sirius-currency-dollar-simple.icon';
export * from './build/sirius-cylinder.icon';
export * from './build/sirius-database.icon';
export * from './build/sirius-desktop.icon';
export * from './build/sirius-device.icon';
export * from './build/sirius-dots-three-horisontal.icon';
export * from './build/sirius-dots-three-vertical.icon';
export * from './build/sirius-download-simple.icon';
export * from './build/sirius-drop.icon';
export * from './build/sirius-envelope-open.icon';
export * from './build/sirius-eraser.icon';
export * from './build/sirius-eye-slash.icon';
export * from './build/sirius-eye.icon';
export * from './build/sirius-facebook-logo.icon';
export * from './build/sirius-file-arrow-down.icon';
export * from './build/sirius-file-arrow-up.icon';
export * from './build/sirius-file-doc.icon';
export * from './build/sirius-file-html.icon';
export * from './build/sirius-file-jpg.icon';
export * from './build/sirius-file-pdf.icon';
export * from './build/sirius-file-png.icon';
export * from './build/sirius-file-ppt.icon';
export * from './build/sirius-file-xls.icon';
export * from './build/sirius-file-zip.icon';
export * from './build/sirius-flame.icon';
export * from './build/sirius-flask.icon';
export * from './build/sirius-fork-knife.icon';
export * from './build/sirius-funnel-simple.icon';
export * from './build/sirius-funnel.icon';
export * from './build/sirius-gauge.icon';
export * from './build/sirius-gear.icon';
export * from './build/sirius-ghost.icon';
export * from './build/sirius-git-branch.icon';
export * from './build/sirius-git-fork.icon';
export * from './build/sirius-globe-stand.icon';
export * from './build/sirius-globe.icon';
export * from './build/sirius-graduation-cap.icon';
export * from './build/sirius-graph.icon';
export * from './build/sirius-hands-clapping.icon';
export * from './build/sirius-handshake.icon';
export * from './build/sirius-headset.icon';
export * from './build/sirius-heart.icon';
export * from './build/sirius-heartbeat.icon';
export * from './build/sirius-house.icon';
export * from './build/sirius-image.icon';
export * from './build/sirius-info.icon';
export * from './build/sirius-instagram-logo.icon';
export * from './build/sirius-leaf.icon';
export * from './build/sirius-link-break.icon';
export * from './build/sirius-link.icon';
export * from './build/sirius-linkedin-logo.icon';
export * from './build/sirius-list-checks.icon';
export * from './build/sirius-list.icon';
export * from './build/sirius-lock-simple-open.icon';
export * from './build/sirius-lock-simple.icon';
export * from './build/sirius-magnifying-glass-minus.icon';
export * from './build/sirius-magnifying-glass-plus.icon';
export * from './build/sirius-magnifying-glass.icon';
export * from './build/sirius-map-pin.icon';
export * from './build/sirius-minus.icon';
export * from './build/sirius-monitor.icon';
export * from './build/sirius-moon.icon';
export * from './build/sirius-needle.icon';
export * from './build/sirius-notepad.icon';
export * from './build/sirius-nut.icon';
export * from './build/sirius-package.icon';
export * from './build/sirius-paint-brush-broad.icon';
export * from './build/sirius-paperclip-horizontal.icon';
export * from './build/sirius-paperclip.icon';
export * from './build/sirius-pencil-ruler.icon';
export * from './build/sirius-pencil.icon';
export * from './build/sirius-person-simple-circle.icon';
export * from './build/sirius-play-circle.icon';
export * from './build/sirius-plugs-connected.icon';
export * from './build/sirius-plugs.icon';
export * from './build/sirius-plus.icon';
export * from './build/sirius-printer.icon';
export * from './build/sirius-puzzle-piece.icon';
export * from './build/sirius-question.icon';
export * from './build/sirius-quotes.icon';
export * from './build/sirius-repeat.icon';
export * from './build/sirius-robot.icon';
export * from './build/sirius-rocket-launch.icon';
export * from './build/sirius-rows.icon';
export * from './build/sirius-ruler.icon';
export * from './build/sirius-scales.icon';
export * from './build/sirius-selection-background.icon';
export * from './build/sirius-share-network.icon';
export * from './build/sirius-shield-check.icon';
export * from './build/sirius-shield.icon';
export * from './build/sirius-shinpinhaologo.icon';
export * from './build/sirius-shopping-cart.icon';
export * from './build/sirius-shuffle-up.icon';
export * from './build/sirius-shuffle.icon';
export * from './build/sirius-sign-in.icon';
export * from './build/sirius-sign-out.icon';
export * from './build/sirius-sliders-horizontal.icon';
export * from './build/sirius-sliders-vertical.icon';
export * from './build/sirius-smalldots-three-horisontal.icon';
export * from './build/sirius-smalldots-three-vertical.icon';
export * from './build/sirius-sparkle.icon';
export * from './build/sirius-speaker-high.icon';
export * from './build/sirius-speaker-slash.icon';
export * from './build/sirius-speaker-x.icon';
export * from './build/sirius-speed-high.icon';
export * from './build/sirius-speed-low.icon';
export * from './build/sirius-speed-medium.icon';
export * from './build/sirius-spotify-logo.icon';
export * from './build/sirius-square-half-horisontal.icon';
export * from './build/sirius-square-half-vertical.icon';
export * from './build/sirius-squares-four.icon';
export * from './build/sirius-stack.icon';
export * from './build/sirius-stamp.icon';
export * from './build/sirius-star.icon';
export * from './build/sirius-sticker.icon';
export * from './build/sirius-student.icon';
export * from './build/sirius-sun.icon';
export * from './build/sirius-swap.icon';
export * from './build/sirius-swatches.icon';
export * from './build/sirius-syringe.icon';
export * from './build/sirius-tag.icon';
export * from './build/sirius-target.icon';
export * from './build/sirius-telegram-logo.icon';
export * from './build/sirius-test-tube.icon';
export * from './build/sirius-thermometer-simple.icon';
export * from './build/sirius-thumbs-down.icon';
export * from './build/sirius-thumbs-up.icon';
export * from './build/sirius-ticket.icon';
export * from './build/sirius-tiktoklogo.icon';
export * from './build/sirius-timer.icon';
export * from './build/sirius-translate.icon';
export * from './build/sirius-trash.icon';
export * from './build/sirius-tree-evergreen.icon';
export * from './build/sirius-tree.icon';
export * from './build/sirius-truck.icon';
export * from './build/sirius-twitter-logo.icon';
export * from './build/sirius-user-circle.icon';
export * from './build/sirius-user-minus.icon';
export * from './build/sirius-user-plus.icon';
export * from './build/sirius-user.icon';
export * from './build/sirius-users-four.icon';
export * from './build/sirius-users-three.icon';
export * from './build/sirius-users-two.icon';
export * from './build/sirius-warning-circle.icon';
export * from './build/sirius-wechatlogo.icon';
export * from './build/sirius-weishilogo.icon';
export * from './build/sirius-world.icon';
export * from './build/sirius-wrench.icon';
export * from './build/sirius-x-circle.icon';
export * from './build/sirius-x-logo.icon';
export * from './build/sirius-x.icon';
export * from './build/sirius-youtube-logo.icon';
export * from './build/sirius-3d-printing-pictogram.icon';
export * from './build/sirius-additional-cost-pictogram.icon';
export * from './build/sirius-archive-box-light-pictogram.icon';
export * from './build/sirius-assembly-pictogram.icon';
export * from './build/sirius-awareness-pictogram.icon';
export * from './build/sirius-barbell-pictogram.icon';
export * from './build/sirius-barcode-pictogram.icon';
export * from './build/sirius-binoculars-pictogram.icon';
export * from './build/sirius-buildings-pictogram.icon';
export * from './build/sirius-car-pictogram.icon';
export * from './build/sirius-certified-integrator-pictogram.icon';
export * from './build/sirius-certified-training-partners-pictogram.icon';
export * from './build/sirius-changing-demands-pictogram.icon';
export * from './build/sirius-chats-light-pictogram.icon';
export * from './build/sirius-circle-wavy-check-pictogram.icon';
export * from './build/sirius-cobot-line-pictogram.icon';
export * from './build/sirius-cobot-pictogram.icon';
export * from './build/sirius-code-light-pictogram.icon';
export * from './build/sirius-collaborative-pictogram.icon';
export * from './build/sirius-competitive-pictogram.icon';
export * from './build/sirius-complete-solutions-pictogram.icon';
export * from './build/sirius-components-pictogram.icon';
export * from './build/sirius-computer-tower-light-pictogram.icon';
export * from './build/sirius-cost-effective-pictogram.icon';
export * from './build/sirius-currency-btc-light-pictogram.icon';
export * from './build/sirius-customer-success-pictogram.icon';
export * from './build/sirius-difficult-setup-pictogram.icon';
export * from './build/sirius-distributors-pictogram.icon';
export * from './build/sirius-drop-half-light-pictogram.icon';
export * from './build/sirius-e-learning-pictogram.icon';
export * from './build/sirius-expert-pictogram.icon';
export * from './build/sirius-face-mask-light-pictogram.icon';
export * from './build/sirius-factory-pictogram.icon';
export * from './build/sirius-file-pdf-pictogram.icon';
export * from './build/sirius-finishing-pictogram.icon';
export * from './build/sirius-flask-pictogram.icon';
export * from './build/sirius-gear-light-pictogram.icon';
export * from './build/sirius-global-ecosystem-pictogram.icon';
export * from './build/sirius-globe-hemisphere-west-pictogram.icon';
export * from './build/sirius-globe-stand-pictogram.icon';
export * from './build/sirius-glueing-dispensing-pictogram.icon';
export * from './build/sirius-hamburger-pictogram.icon';
export * from './build/sirius-heartbeat-light-pictogram.icon';
export * from './build/sirius-iiot-pictogram.icon';
export * from './build/sirius-increased-competition-pictogram.icon';
export * from './build/sirius-industry-5-pictogram.icon';
export * from './build/sirius-injection-molding-pictogram.icon';
export * from './build/sirius-iot-pictogram.icon';
export * from './build/sirius-labour-shortage-pictogram.icon';
export * from './build/sirius-machine-tending-pictogram.icon';
export * from './build/sirius-map-pin-line-pictogram.icon';
export * from './build/sirius-map-pin-pictogram.icon';
export * from './build/sirius-material-handling-old-pictogram.icon';
export * from './build/sirius-material-handling-pictogram.icon';
export * from './build/sirius-material-removal-pictogram.icon';
export * from './build/sirius-newbizz-pictogram.icon';
export * from './build/sirius-nut-pictogram.icon';
export * from './build/sirius-online-training-pictogram.icon';
export * from './build/sirius-palletizing-old-pictogram.icon';
export * from './build/sirius-palletizing-packaging-pictogram.icon';
export * from './build/sirius-palletizing-pictogram.icon';
export * from './build/sirius-pick-place-pictogram.icon';
export * from './build/sirius-planet-pictogram.icon';
export * from './build/sirius-post-purchase-pictogram.icon';
export * from './build/sirius-precision-pictogram.icon';
export * from './build/sirius-predictive-maintenance-pictogram.icon';
export * from './build/sirius-productive-pictogram.icon';
export * from './build/sirius-projector-screen-pictogram.icon';
export * from './build/sirius-quality-inspection-pictogram.icon';
export * from './build/sirius-quotes-pictogram.icon';
export * from './build/sirius-retention-pictogram.icon';
export * from './build/sirius-risk-assessment-pictogram.icon';
export * from './build/sirius-robot-pictogram.icon';
export * from './build/sirius-ruler-pictogram.icon';
export * from './build/sirius-safety-helmet-pictogram.icon';
export * from './build/sirius-scales-pictogram.icon';
export * from './build/sirius-screwdriver-pictogram.icon';
export * from './build/sirius-services-pictogram.icon';
export * from './build/sirius-signpost-pictogram.icon';
export * from './build/sirius-sim-card-pictogram.icon';
export * from './build/sirius-sliders-horizontal-light-pictogram.icon';
export * from './build/sirius-space-requirements-pictogram.icon';
export * from './build/sirius-sparkle-pictogram.icon';
export * from './build/sirius-star-pictogram.icon';
export * from './build/sirius-straightforward-pictogram.icon';
export * from './build/sirius-supply-chain-pictogram.icon';
export * from './build/sirius-target-light-pictogram.icon';
export * from './build/sirius-timer-light-pictogram.icon';
export * from './build/sirius-user-gear-light-pictogram.icon';
export * from './build/sirius-user-list-pictogram.icon';
export * from './build/sirius-users-three-pictogram.icon';
export * from './build/sirius-warning-light-pictogram.icon';
export * from './build/sirius-welding-pictogram.icon';
export * from './build/sirius-wrench-pictogram.icon';
export * from './build/sirius-x-circle-pictogram.icon';
export * from './build/complete-icon-set';
export * from './build/sirius-icons.model';
